import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Remove image imports and use a placeholder image or your own image path
const placeholderImg = "https://via.placeholder.com/300x200?text=Project+Image";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          
          <Col md={4} className="project-card">
            <ProjectCard
              
              isBlog={false}
              title="Telugu News Website"
              description="A news web application built to deliver the latest updates in Telugu. Designed with a clean UI and responsive frontend for better readability."
              ghLink="https://github.com/Divyateja2709/telugu-news-website"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              
              isBlog={false}
              title="Chedharangam"
              description="A chess-inspired project built with a focus on logic, rules, and player interactions. Implemented using modern programming practices."
              ghLink="https://github.com/Divyateja2709/chedharangam"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              
              isBlog={false}
              title="Gas Detection IoT Project"
              description="An IoT-based gas detection system using Arduino and sensors for smart home safety. Sends alerts when gas levels exceed safe limits."
              ghLink="https://github.com/Divyateja2709/gas-detection-sensor-iot-project"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;